import { render, staticRenderFns } from "./EmptyMessage.vue?vue&type=template&id=679a7f54&scoped=true&"
import script from "./EmptyMessage.vue?vue&type=script&lang=ts&"
export * from "./EmptyMessage.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyMessage.vue?vue&type=style&index=0&id=679a7f54&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../.yarn/__virtual__/vue-loader-virtual-93e13427ca/0/cache/vue-loader-npm-15.9.8-438f4d0ff0-ca4c99b261.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679a7f54",
  null
  
)

export default component.exports